export default "__VITE_ASSET__sZN5UrT3__"